import { COUNTRIES } from './constants';
import { nameToSlug } from './country-utils';

const countrySlugs = new Set(COUNTRIES.map(country => nameToSlug(country.name)));

/** Deliberately bounded categories: never return a private path, query or label. */
export function pageArea(pathname: string): string | null {
  if (pathname === '/') return 'home';
  const fixed: Record<string, string> = {
    '/track': 'tracking', '/schedules': 'schedules', '/directory': 'directory',
    '/pricing': 'pricing', '/blog': 'blog', '/login': 'login',
    '/forwarders/login': 'login', '/signup': 'signup', '/shipper-signup': 'signup',
    '/dashboard/my-shipments': 'saved_shipments',
  };
  if (fixed[pathname]) return fixed[pathname];
  if (/^\/blog\/[a-z0-9-]+\/?$/.test(pathname)) return 'article';
  if (/^\/forwarders\/(?!dashboard(?:\/|$)|login(?:\/|$))[a-z0-9-]+\/?$/.test(pathname)) return 'forwarder_profile';
  const parts = pathname.replace(/\/$/, '').split('/').slice(1);
  if (countrySlugs.has(parts[0])) {
    if (parts.length === 1 || (parts[1] === 'directory' && (parts.length === 2 || (parts.length === 3 && /^\d+$/.test(parts[2]))))) return 'country_directory';
    if (parts.length === 2 && /^[a-z0-9-]+$/.test(parts[1])) return 'forwarder_profile';
  }
  return null;
}

/** Visible time is a rough attention signal, never proof of reading or success. */
export function visibleTimeBucket(seconds: number): string {
  return seconds < 10 ? 'under_10s' : seconds < 30 ? '10_29s' : seconds < 60 ? '30_59s' : '60s_plus';
}

export function scrollBucket(top: number, height: number, viewport: number): number {
  // Short pages do not prove the user scrolled through content.
  if (height <= viewport) return 0;
  const percent = Math.min(100, Math.max(0, (top + viewport) / height * 100));
  return percent >= 90 ? 90 : percent >= 50 ? 50 : percent >= 25 ? 25 : 0;
}

/** Persist QA labelling across same-tab navigation, without identifying a visitor. */
export function visitorTrafficType(): 'internal_qa' | undefined {
  if (typeof window === 'undefined') return;
  try {
    const marked = new URLSearchParams(window.location.search).get('utm_source') === 'internal_qa';
    if (marked) {
      try { sessionStorage.setItem('shipzy-internal-qa', '1'); } catch { /* optional storage */ }
      return 'internal_qa';
    }
    if (sessionStorage.getItem('shipzy-internal-qa') === '1') return 'internal_qa';
  } catch { /* Analytics must not affect the product. */ }
}
